import { render } from "./Formfileupload.vue?vue&type=template&id=5ab64531"
import script from "./Formfileupload.vue?vue&type=script&lang=js"
export * from "./Formfileupload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__